import React from "react";

export default class Errors extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const errors = this.formatErrors(this.props.errors);

    if (errors && errors.length) {
      return (
        <div className="alert alert-danger" style={this.props.style}>
          <ul className="errors-list">
            {errors.map((error, idx) => {
              return (
                <li key={idx} dangerouslySetInnerHTML={{ __html: error }}></li>
              );
            })}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }

  formatErrors(errors) {
    if (errors) {
      if (Array.isArray(errors)) {
        return errors;
      } else {
        return Object.keys(errors).map((key) => {
          return `${I18n.t(key)} ${this.formatSentence(errors[key])}`;
        });
      }
    } else {
      return [];
    }
  }

  formatSentence(errors) {
    if (typeof errors === "string") {
      return errors + '.';
    } else if (Array.isArray(errors)) {
      if (errors.length === 1) {
        return errors[0] + '.';
      }
      return errors.slice(0, errors.length - 1).join(', ') + " " + I18n.t('and') + " " + errors.slice(-1) + '.';
    }
  }
}
